import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { FieldDef } from 'app/core/models';

/**
 * Directive to wrap text in a cell if it exceeds a certain threshold value.
 * Used in fields of type text and textarea.
 * Threshold values specifies the number of characters after which the text will be wrapped.
 * inputReference is the reference to the edit input element in the cell.
 */
@Directive({
  selector: '[cellTextWrap]',
})
export class CellTextWrapDirective implements AfterViewInit {
  @Input('cellTextWrap') fieldDef: FieldDef;

  private threshold = {
    min: 100,
    max: 150,
  } as { min: number; max: number };

  private get element(): HTMLDivElement {
    return this.elementRef.nativeElement;
  }

  private get isTextOrTextareaField(): boolean {
    return this.fieldDef && (this.fieldDef.type === 'textarea' || this.fieldDef.type === 'text');
  }

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngAfterViewInit(): void {
    if (this.isTextOrTextareaField) {
      this.wrapText();
    }
  }

  private wrapText(): void {
    const characterCount = this.element.innerText.length;
    const maxWidth = characterCount >= this.threshold.min && characterCount < this.threshold.max ? 250 : 300;
    const maxHeight = characterCount >= this.threshold.min && characterCount < this.threshold.max ? 80 : 120;

    const styles = {
      '-webkit-line-clamp': 'unset',
      'word-break': 'normal',
      'min-width': '100%',
      'max-width': maxWidth + 'px',
      height: 'auto',
      'max-height': maxHeight + 'px',
      'overflow-y': 'auto',
    };

    for (const [key, value] of Object.entries(styles)) {
      this.renderer.setStyle(this.element, key, value);
    }
  }
}
